import { render } from "./update-task-view.vue?vue&type=template&id=97c9894a"
import script from "./update-task-view.vue?vue&type=script&lang=js"
export * from "./update-task-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__